import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Base from './base';
/**
 * `Service` The cde settings service
 */
var CdeSettings = /*#__PURE__*/function (_Base) {
  /**
   * Create the cde settings service instance.
   *
   * @param sdk - the SDK instance
   */
  function CdeSettings(sdk) {
    _classCallCheck(this, CdeSettings);
    return _callSuper(this, CdeSettings, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(CdeSettings, _Base);
  return _createClass(CdeSettings, [{
    key: "getCdeSettings",
    value: (
    /**
     * Get the cde settings of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/7ed822c0419a9-get-project-cde-settings
     *
     * @param projectId -  the project id.
     * @param config - the object to overwrite request parameters.
     */
    function () {
      var _getCdeSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, config) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.HttpService.dmV2.get("/projects/".concat(projectId, "/cde-settings"), config);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCdeSettings(_x, _x2) {
        return _getCdeSettings.apply(this, arguments);
      }
      return getCdeSettings;
    }()
    /**
     * Update the cde settings of the project
     * https://platform.stoplight.autodesk.com/docs/docs-cp/abd3fdbc0528e-update-project-cde-settings
     *
     * @param projectId -  the project id.
     * @param settings - the settings.
     * @param config - the object to overwrite request parameters.
     */
    )
  }, {
    key: "updateCdeSettings",
    value: (function () {
      var _updateCdeSettings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, settings, config) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.HttpService.dmV2.patch("/projects/".concat(projectId, "/cde-settings"), settings, config);
            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateCdeSettings(_x3, _x4, _x5) {
        return _updateCdeSettings.apply(this, arguments);
      }
      return updateCdeSettings;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'CdeSettings';
    }
  }]);
}(Base);
export default CdeSettings;